<div class="panel-container" [ngClass]="{ 'panel-open p-4': open() === true, 'panel-closed': open() !== true }">
  @if (open() === true) {
    <ng-content />
  }
</div>
